// extracted by mini-css-extract-plugin
export var attachment = "_rp-a";
export var emailContainer = "_rp-4";
export var emailContentPaddedContainer = "_rp-b";
export var emailHeader = "_rp-6";
export var emailIframe = "_rp-3";
export var emailInfoIcon = "_rp-9";
export var emailShortenedSummary = "_rp-e";
export var infoDropdown = "_rp-0";
export var infoRowBoundedContent = "_rp-d";
export var internal = "_rp-5";
export var merchant = "_rp-8";
export var messageInputContainer = "_rp-h";
export var normal = "_rp-7";
export var replyCard = "_rp-f";
export var subtleButton = "_rp-1";
export var subtleButtonIconContainer = "_rp-2";
export var toggleViewRepliesButton = "_rp-c";
export var wrappingText = "_rp-g";